import { render, staticRenderFns } from "./DocumentPageCanvas.vue?vue&type=template&id=8ada09f8&"
import script from "./DocumentPageCanvas.vue?vue&type=script&lang=ts&"
export * from "./DocumentPageCanvas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports